/**
 * @module components/accordion
 */;

/**
 * @classdesc Аккордион
 */
class Accordion {
  constructor(el) {
    /**
     * @member {Object}
     * @property {String} section - css-class родительской секции
     * @property {String} container - css-class для секций аккордиона 
     * @property {String} selected - css-class для развёрнутой секции аккордиона
     * @property {String} button - css-class для кнопок, по которым раскрывается/скрывается содержимое
     * @property {String} content - css-class для скрытого/раскрываемого содержимого
     */
    this.data = {
      section: el.section,
      container: el.container,
      selected: el.selected,
      button: el.button,
      content: el.content
    };
    this.init();
  }

  /**
   * @method
   * @description Инициализация аккордиона. Навешивание обработчиков событий на кнопки
   */
  init() {
    let data = this.data;
    const section = document.querySelector(`.${data.section}`)
    const cards = Array.from(section.getElementsByClassName(data.container))
    const crosses = Array.from(section.getElementsByClassName(data.button))

    crosses.forEach((cross, idx) =>
      cross.addEventListener(
        'click',
        () => this.onClick(idx, cards, section)
      )
    )
  }

  /**
   * @method
   * @description Обработка нажатия кнопок. Скрытие/раскрытие секций аккордиона
   */
  onClick(idx, cards, section) {
    let data = this.data
    let $target = section.querySelector(`.${data.container}__${idx + 1}`)
    let targetIsSelected = $target.classList.contains(data.selected)
    let $content = $target.querySelector(`.${data.content}`)
    let styles = $content.style

    cards.forEach(card => {
      let cardContent = card.querySelector(`.${data.content}`)
      let styles = cardContent.style

      if (card.classList.contains(data.selected)) {

        card.classList.remove(data.selected)

        Object.assign(
          styles,
          {
            height: '0',
            marginBottom: ''
          })

        requestAnimationFrame(() => {
          setTimeout(
            () => Object.assign(styles, { transition: '' }),
            500)
        })
      }
    })

    if (!targetIsSelected) {
      let paddingTop = window.getComputedStyle($target, null).getPropertyValue('padding-top')

      Object.assign(
        styles,
        {
          opacity: '1',
          top: '-100%',
          left: '-100%',
          marginBottom: paddingTop,
          width: '100%',
          height: 'auto'
        }
      )

      let contentRect = $content.getBoundingClientRect()
      $target.classList.add(data.selected)

      Object.assign(
        styles,
        {
          height: '0',
          opacity: '1',
          top: 'unset',
          left: 'unset',
          transition: 'height .3s ease-out'
        }
      )

      requestAnimationFrame(
        () => Object.assign(
          styles,
          {
            height: `${contentRect.height}px`
          }
        )
      )
    }
  }
}

export default Accordion;